import React from 'react';
import intl from 'react-intl-universal';
import { Button } from 'antd';
import LOCAL_COMPUTER from '@/assets/OpenSaveCombine/localComputer.svg';

const noop = () => { };

function SaveAsTabPanel() {
    return <>
        <i className="save-as tab-icon m-r-8" />
        <span className="tab-text">{intl.formatMessage({ id: 'CommonPanel.SaveAs' })}</span>
    </>
}

function SaveAsTabContent({ onSaveAs = noop }) {
    return <div className="local-computer-content">
        {/* <div className="header-wrapper">{intl.formatMessage({ id: 'CommonPanel.SaveAs' })}</div> */}
        <div className="click-download-file-btn-wrapper">
            <p className="ant-upload-drag-icon">
                <img src={LOCAL_COMPUTER} />
            </p>
            <p className="ant-upload-text">{intl.formatMessage({ id: 'CommonPanel.SaveAsToLocalComputer' })}</p>
            <Button onClick={onSaveAs} type="primary">
                {intl.formatMessage({ id: 'CommonPanel.SaveAs' })}
            </Button>
        </div>
    </div>
}

export default function getSaveAsTabPan({ onSaveAs }) {
    return {
        key: 'SAVE_AS',
        category: 'local',
        tab: <SaveAsTabPanel />,
        content: <SaveAsTabContent onSaveAs={onSaveAs} />,
    }
};